import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import theme from "./Theme";
import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import OrangeHighlightButton from "./OrangeHighlightButton";

const EnrollFrame: React.FC = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const history = useHistory();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleRedirection = () => {
    const path =
      currentLanguage === "en" ? "/enroll" : `/${currentLanguage}/enroll`;
    history.push(path);
  };

  return (
    <>
      <Divider
        sx={{
          borderColor: theme.palette.text.secondary,
          borderBottomWidth: "3px",
        }}
      />
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          display: "flex",
          flexDirection: "column",
          paddingTop: "30px",
          px: isMobile ? "20px" : "73px",
          mb: isMobile ? "10vh" : "20vh",
          mt: isMobile ? "4vh" : "8vh",
        }}
      >
        <Box sx={{ flexGrow: 3 }} />
        <Typography
          variant="h2"
          fontWeight="800"
          mx="auto"
          mb="0"
          textAlign="center"
          color={theme.palette.text.secondary}
        >
          {t("EnrollFrame.title")}
        </Typography>
        <Box sx={{ minHeight: "2vh" }} />
        <Typography variant={"h4"} textAlign="center">
          {t("EnrollFrame.subtitle")}
          {currentLanguage === "en" ? " " : <br />}
          {t("EnrollFrame.subtitle0")}
        </Typography>
        <Box sx={{ minHeight: "5vh" }} />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center",
          }}
        >
          <OrangeHighlightButton onClick={handleRedirection}>
            <Typography variant="h5">{t("EnrollFrame.button")}</Typography>
          </OrangeHighlightButton>
          <Typography variant="h5">{t("EnrollFrame.text")}</Typography>
        </Box>
      </Box>
    </>
  );
};

export default EnrollFrame;
